















export default {
    props: ['techDocs'],
    methods: {
        downloadFile(item) {
            item.url && (window.location.href = item.url);
        },
    },
};
